import { NgModule } from '@angular/core';
import { AdminRoutingModule } from './admin-routing.module';
import { AdminComponent } from './admin.component';
import { SharedModule } from '../shared/shared.module';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [AdminComponent],
  imports: [SharedModule, CommonModule, AdminRoutingModule],
})
export class AdminModule {}
